import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  top: -50px;
  background-color: green;
  width: 100%;
  height: 50px;
`;
